import React from "react";
import { useLanguage } from "../hooks/LanguageContext";
import "../styles/components/Navbar.css";
import Flags from "country-flag-icons/react/3x2";

function Navbar({ toggleSidebar, isMobile, currentRoute }) {
  const { isEnglish, toggleLanguage } = useLanguage();

  return (
    <header className="navbar">
      {isMobile && (
        <button
          type="button"
          className="sidebar-toggle"
          onClick={toggleSidebar}
          aria-label={isEnglish ? "Open menu" : "Abrir menú"}
        >
          ☰
        </button>
      )}
      <div className="route-name">
        <span>{currentRoute}</span>
      </div>

      <div className="navbar-controls">
        <label className="switch" aria-label="Language">
          <input
            type="checkbox"
            checked={isEnglish}
            onChange={toggleLanguage}
          />
          <div className="slider">
            <span className="flag spain">
              <Flags.ES title="Español" />
            </span>
            <span className="flag uk">
              <Flags.GB title="English" />
            </span>
          </div>
        </label>
      </div>
    </header>
  );
}

export default Navbar;
